import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
import { reduce, map, set, differenceWith, uniqBy } from "lodash";
const initialState = {
  data: null,
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchItemBoxOfficeDataApi = createAsyncThunk(
  "itemBoxOfficeData/fetchItemBoxOfficeDataApi",
  async ({ id }) => {
    const response = await axiosInstance.request({
      url: `boxoffice/${id}/all`,
      method: "GET",
    });
    return response;
  }
);

const itemBoxOfficeDataSlice = createSlice({
  name: "itemBoxOfficeData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchItemBoxOfficeDataApi.pending, (state) => {
        set(state, "loading", true);
        set(state, "data", null);
      })
      .addCase(fetchItemBoxOfficeDataApi.fulfilled, (state, action) => {
        set(state, "completed", true);
        set(state, "data", action?.payload?.data || null);
        set(state, "loading", false);
      })
      .addCase(fetchItemBoxOfficeDataApi.rejected, (state, action) => {
        set(state, "completed", true);
        set(state, "loading", false);
        set(state, "hasError", true);
        set(state, "message", action?.error?.message || "");
      });
  },
});

const itemBoxOfficeDataReducer = itemBoxOfficeDataSlice.reducer;

export default itemBoxOfficeDataReducer;

export const itemBoxOfficeDataActions = itemBoxOfficeDataSlice.actions;
